<template>
  <div class="app-container">
    <el-tabs v-model="tabName" @tab-click="handleClick" type="card">
      <el-tab-pane label="应收期初" name="rec"></el-tab-pane>
      <el-tab-pane label="应付期初" name="pay"></el-tab-pane>
    </el-tabs>
    <list ref="list" :is-payment="type">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="edit(row.BeginningId)">编辑</el-button>
            <el-button type="text" @click="delRows(row.BeginningId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <rec-dialog ref="recDialog" @close-saved="reload" />
    <pay-dialog ref="payDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sys/init/trade/list";
import recDialog from "@/components/sys/init/trade/recDialog";
import payDialog from "@/components/sys/init/trade/payDialog";

export default {
  name: "init_trade",
  mixins: [curdMixins],
  components: {
    list,
    recDialog,
    payDialog,
  },
  data() {
    return {
      type: true,
      tabName: "rec",
      api: require("@/api/sy/trade").default,
    };
  },
  methods: {
    handleClick(e) {
      this.type = this.tabName == "rec";
      this.$refs.list.getData({ Payment: this.tabName != "rec" });
    },
    create() {
      this.$refs[this.tabName + "Dialog"].openCreate();
    },
    edit(id) {
      this.$refs[this.tabName + "Dialog"].openEditById(id);
    },
    delRows(Id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id }).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.$refs.list.reload();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>